// extracted by mini-css-extract-plugin
module.exports = {"CasusPage":"CasusPage_CasusPage__BQ4JE"};